import { render } from "./TableData2Show.vue?vue&type=template&id=d8f834b0&scoped=true"
import script from "./TableData2Show.vue?vue&type=script&lang=js"
export * from "./TableData2Show.vue?vue&type=script&lang=js"

import "./TableData2Show.vue?vue&type=style&index=0&id=d8f834b0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8f834b0"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/TableData2Show.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d8f834b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d8f834b0', __exports__)) {
    api.reload('d8f834b0', __exports__)
  }
  
  module.hot.accept("./TableData2Show.vue?vue&type=template&id=d8f834b0&scoped=true", () => {
    api.rerender('d8f834b0', render)
  })

}


export default __exports__